import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {type FC, useState} from 'react';
import {type Device, DeviceListView, type Track, TrackMapView} from 'talptech-gis-components';
import Layout from '../components/Layout';

const TrackMapPage: FC = () => {
  const [selectedDevice, setSelectedDevice] = useState<Device>();
  const [selectedTrack, setSelectedTrack] = useState<Track>();

  const sidePanelContent = (
    <Stack sx={wrapperSx}>
      <Box sx={contentSx}>
        <DeviceListView selectedDevice={selectedDevice} onSelectedDevice={setSelectedDevice} />
      </Box>
    </Stack>
  );

  const mainContent = (
    <TrackMapView selectedDevice={selectedDevice} selectedTrack={selectedTrack} onSelectedTrack={setSelectedTrack} />
  );

  return <Layout sidePanelContent={sidePanelContent} mainContent={mainContent} closeSidePanelOn={selectedTrack} />;
};

export default TrackMapPage;

const wrapperSx = {
  height: '100%',
  overflow: 'hidden',
};

const contentSx = {
  flexGrow: 1,
  overflow: 'auto',
};
